import React, { useContext, useState, useEffect, Fragment } from "react";
import { Stack, Box, Typography, Divider } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
// icon
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import SchoolIcon from "@mui/icons-material/School";
import { FaUsersGear } from "react-icons/fa6";
import { IoCalendarSharp } from "react-icons/io5";
import { BiSolidSchool } from "react-icons/bi";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { SiGoogleclassroom } from "react-icons/si";

//Srcs
import "../../Style/pageStyle.scss";

import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function Setting() {
  // ===================== Change Language ==========================
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const location = useLocation();
  const navigate = useNavigate();

  const SettingData = [
    {
      main_title: t(`thead_manage_user`),
      sub_item: [
        {
          RouteTo: "/setting/user",
          Title: t("user"),
          Icon: <FaUsersGear className="icons" />,
          // Icon: <img alt="user" className="image" src={user} />,
          Description: t("des_user"),
        },
      ],
    },
    {
      main_title: t(`thead_manage_school`),
      sub_item: [
        {
          RouteTo: "/setting/academic-year",
          Title: t("academic_year"),
          Icon: <IoCalendarSharp className="icons" />,
          // Icon: <img alt="user" className="image" src={user} />,
          Description: t("des_academic_year"),
        },
        {
          RouteTo: "/setting/school",
          Title: t("school"),
          Icon: <BiSolidSchool className="icons" />,
          // Icon: <img alt="user" className="image" src={user} />,
          Description: t("des_school"),
        },
        {
          RouteTo: "/setting/level",
          Title: t("grade_level"),
          Icon: <EqualizerIcon className="icons" />,
          // Icon: <img alt="user" className="image" src={user} />,
          Description: t("des_grade_level"),
        },
        {
          RouteTo: "/setting/group",
          Title: t("group"),
          Icon: <AccountTreeIcon className="icons" />,
          // Icon: <img alt="user" className="image" src={user} />,
          Description: t("des_group"),
        },
        // {
        //   RouteTo: "/setting/class",
        //   Title: t("class"),
        //   Icon: <SiGoogleclassroom className="icons" />,
        //   Description: t("des_class"),
        // },
      ],
    },
    {
      main_title: t(`thead_manage_dream_class`),
      sub_item: [
        {
          RouteTo: "/setting/class",
          Title: t("dream_class"),
          Icon: <SiGoogleclassroom className="icons" />,
          Description: t("des_class"),
        },
      ],
    },
  ];
  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`page-setting`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ mt: "30px" }}>
        <Grid container spacing={2}>
          {SettingData?.map((e, index) => {
            return (
              <Fragment key={index}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                  <Stack direction="row" spacing={2}>
                    <DisplaySettingsIcon style={{ color: "#158843" }} />
                    <Typography>{e?.main_title}</Typography>
                  </Stack>
                </Grid>
                {e?.sub_item?.map((item, indexSub) => {
                  return (
                    <Grid
                      size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }}
                      key={indexSub}
                    >
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        className="setting-card-container"
                        onClick={() => navigate(item?.RouteTo)}
                      >
                        <Stack direction="column" spacing={0.5}>
                          <Typography
                            className={
                              language === "en" ? "title-txt" : "title-txt-kh"
                            }
                          >
                            {item?.Title}
                          </Typography>
                          <Typography
                            className={
                              language === "en"
                                ? "subtitle-txt"
                                : "subtitle-txt-kh"
                            }
                          >
                            {item?.Description}
                          </Typography>
                        </Stack>
                        <Stack direction={`row`}>
                          <Stack
                            direction={`column`}
                            justifyContent={`center`}
                            alignItems={"center"}
                            className="icons-bg"
                          >
                            {item?.Icon}
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>
                  );
                })}
              </Fragment>
            );
          })}
        </Grid>
      </Box>
    </div>
  );
}
